module.exports = __webpack_public_path__ + "static/media/post-event.d15fdc71.png";